import PropTypes from 'prop-types';
import React from 'react';
import Validator from 'mixins/validator';
import Resetter from 'mixins/resetter';
import { Dialog, IconButton } from 'react-toolbox';
import { connect } from 'react-redux';
import PoDetails from 'createException/poDetails';
import S from 'modal.scss';
import styles from 'styles/input.scss';
import {
  clearValidation, createExceptionItem, updatePhaseTask,
} from 'actionCreators';
import { requestPricePatchLineItemList } from 'actionCreators/dropdown_lists';
import { requestPhaseItems } from 'actionCreators/phase_items';
import { getPhaseErrors } from '../../../../../../reducers';
import PhaseType from 'types/phase';

class CreateExceptionModal extends Resetter(Validator(React.Component)) {
  constructor(props) {
    super(props);
    this.setPoDetailsMounted = this.setPoDetailsMounted.bind(this);
    this.state = {
      number: '',
      total: 0,
      lineItems: [],
      message: 'Exception created through the Action Button',
      errors: {},
      poDetailsMounted: false,
      contact: '',
      reason: '',
    };
  }

  static VALIDATIONS = { total: true, lineItems: true }

  componentWillUpdate = (nextProps, nextState) =>
    (nextProps.active && nextState.poDetailsMounted ?
      this.props.requestPricePatchLineItemList(this.props.phase.id) :
      null);

  setPoDetailsMounted = isMounted => this.setState({ poDetailsMounted: isMounted })

  handleClose() {
    super.handleClose();
    this.props.clearValidation();
    document.location.reload();
  }

  updateFormData = data => this.setState(data, () => {
    if (!this.validate()) return;
    const { number, total, message, lineItems, reason, contact } = this.state;
    this.props.createExceptionItem({
      number,
      kind: 'Exception',
      invoice_status: 'Not Invoiced',
      total,
      message,
      line_items: lineItems,
      phase_id: this.props.phase.id,
      reason,
      contact,
    }).then(() => this.handleClose());
  });

  render = () => {
    const { phase, active, errors: serverErrors } = this.props;
    const { number, total, lineItems, reason, contact } = this.state;
    return (<Dialog
      active={active} className={S.modal} type="fullscreen"
      onEscKeyDown={this.handleClose} onOverlayClick={this.handleClose}
    >
      <div className={styles.errored}>
        {Object.keys(serverErrors).length > 0 &&
          <span className={styles.error}>This action could not be completed.</span>}
      </div>
      <IconButton icon="close" className={S.close} onClick={this.handleClose} />
      <h5>Create Exception</h5>
      <PoDetails
        phase={phase}
        number={number}
        setPoDetailsMounted={this.setPoDetailsMounted}
        updateFormData={this.updateFormData}
        total={total}
        lineItems={lineItems}
        reason={reason}
        contact={contact}
      />
    </Dialog>);
  }
}

CreateExceptionModal.propTypes = {
  active: PropTypes.bool.isRequired,
  clearValidation: PropTypes.func.isRequired,
  createExceptionItem: PropTypes.func.isRequired,
  requestPhaseItems: PropTypes.func.isRequired,
  requestPricePatchLineItemList: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  phase: PhaseType.isRequired,
  errors: PropTypes.shape({
    name: PropTypes.arrayOf(PropTypes.string),
  }),
};

CreateExceptionModal.defaultProps = { active: false };

export default connect(state => ({ errors: getPhaseErrors(state) }), {
  clearValidation,
  createExceptionItem,
  updatePhaseTask,
  requestPhaseItems,
  requestPricePatchLineItemList,
})(CreateExceptionModal);



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/components/createExceptionModal.jsx